import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";

import { type TypographyProps } from "~/common/mui";
import ProductMMD from "~/domains/product/components/ProductMMD";

type Props = BaseProductElementProps & Omit<TypographyProps, "children">;

export const shouldRenderMMDTag = (product: ReturnType<typeof useProductContext>) => {
  return !!product.marketDesignation;
};

export const MMDChip = (props: Props) => {
  const product = useProductContext(props);

  if (!shouldRenderMMDTag(product)) {
    return null;
  }

  return <ProductMMD marketDesignation={product.marketDesignation} />;
};
